import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClientProvider } from "@tanstack/react-query";
import App from "@/App";
import { queryClient } from "@/lib/queryClient";
import { applyBrandToDocument, currentBrand } from "@/lib/brand";
import "@/index.css";

// Apply per-host branding before first render so CSS variables and title are
// in place when the SPA paints.
applyBrandToDocument(currentBrand());

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
);
